module.exports = __webpack_public_path__ + "img/model_300.6d3f4dbe.jpg";